// request.tsx
import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL || "";

/** Interfaz para el payload de Add/Update Data Center */
export interface AddDataCenterPayload {
	datacenterId: string;
	name: string;
	direction: string;
	gps: string;
	status: string;
	capacityKW: string; // se envía como string al backend
	phase: string;
	cage: string;
	rackId: string;
	rackCapacity: string;
	patchPanelODF: string;
	rackSecurityPin: string;
	visible: boolean;
	providerId: string;
	providerCode: string;
	city: string;
	displayName: string;
}

/**
 * GET datacenter list
 */
export function getDataCenters(token: string) {
	return axios.get(`${API_URL}/v1/resource-manager/ke-dci`, {
		headers: {
			Authorization: `Bearer ${token}`,
		},
	});
}

/**
 * GET datacenter by Id
 */
export function getDataCenterId(token: string, dcId: string ) {
	return axios.get(`${API_URL}/v1/resource-manager/ke-dci/${dcId}`, {
		headers: {
			Authorization: `Bearer ${token}`,
		},
	});
}

/**
 * POST /v1/dataCenters/add
 */
export function addDataCenter(token: string, payload: AddDataCenterPayload) {
	return axios.post(`${API_URL}/v1/resource-manager/datacenters`, payload, {
		headers: {
			Authorization: `Bearer ${token}`,
			"Content-Type": "application/json",
		},
	});
}

/**
 * PUT /v1/dataCenters/:id
 */
export function updateDataCenter(
	token: string,
	datacenterId: string,
	payload: AddDataCenterPayload
) {
	const encodedId = encodeURIComponent(datacenterId);
	return axios.put(`${API_URL}/v1/resource-manager/datacenters/${encodedId}`, payload, {
		headers: {
			Authorization: `Bearer ${token}`,
			"Content-Type": "application/json",
		},
	});
}

/**
 * DELETE /v1/dataCenters/:id
 */
export function deleteDataCenter(token: string, datacenterId: string) {
	const encodedId = encodeURIComponent(datacenterId);
	return axios.delete(`${API_URL}/v1/resource-manager/datacenters/${encodedId}`, {
		headers: {
			Authorization: `Bearer ${token}`,
		},
	});
}


/**
 * GET providers ids-names
 */
export function getProviderIds( token: string){
	return axios.get(`${API_URL}/v1/resource-manager/providers/ids-names`, {
	//return axios.get(`${API_URL}/v1/provider/ids-and-names`, {  v1/resource-manager/providers/ids-names
		headers: {
			Authorization: `Bearer ${token}`,
		},
	});
}

/**
 * GET providers by id
 */
export function getProviderById( token: string){
	return axios.get(`${API_URL}/v1/resource-manager/providers/id`, {
	//return axios.get(`${API_URL}/v1/provider/ids-and-names`, {
		headers: {
			Authorization: `Bearer ${token}`,
		},
	});
}